import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'mstar-heading',
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeadingComponent { }
